import { TransactionDiscountAmount } from './TransactionDiscountAmount';
import { TransactionAmountRow } from './TransactionAmountRow';
import { useTranslation } from 'react-i18next';
import { Separator, Typography } from '@heroui/react';
import type { SalesTransaction } from '@/api/models';
import { getNodeTestIdProp } from '@/utils';
import { TransactionDiscountChip } from './TransactionDiscountChip';
import { TransactionDiscountNote } from './TransactionDiscountNote';

type TransactionSaleDiscountProps = {
    discount: SalesTransaction['cartDiscount'];
};
export const TransactionSaleDiscount = ({
    discount,
}: TransactionSaleDiscountProps) => {
    const { t } = useTranslation('pages');
    return (
        <>
            {discount && (
                <>
                    <Separator />
                    <div
                        {...getNodeTestIdProp(
                            'transaction-detail-discount-row',
                        )}
                    >
                        <TransactionAmountRow
                            label={
                                <div className="min-w-0">
                                    <div className="flex flex-wrap items-center gap-2">
                                        <Typography
                                            type="body-sm"
                                            color="muted"
                                            {...getNodeTestIdProp(
                                                'transaction-detail-discount-amount-label',
                                            )}
                                        >
                                            {t(
                                                'sales.widgets.transactions.modal.saleDiscount',
                                            )}
                                        </Typography>
                                        <span
                                            {...getNodeTestIdProp(
                                                'transaction-detail-sale-discount-chip',
                                            )}
                                        >
                                            <TransactionDiscountChip
                                                discount={discount}
                                                scope="sale"
                                            />
                                        </span>
                                    </div>
                                    {discount.note && (
                                        <div
                                            {...getNodeTestIdProp(
                                                'transaction-detail-sale-discount-note',
                                            )}
                                        >
                                            <TransactionDiscountNote
                                                note={discount.note}
                                            />
                                        </div>
                                    )}
                                </div>
                            }
                        >
                            <span
                                {...getNodeTestIdProp(
                                    'transaction-detail-discount-amount',
                                )}
                            >
                                <TransactionDiscountAmount
                                    amountTetri={discount.amountTetri}
                                />
                            </span>
                        </TransactionAmountRow>
                    </div>
                </>
            )}
        </>
    );
};
